import { writable } from 'svelte/store';
import { ImageUploadServiceClient } from '../proto/image_upload_grpc_web_pb';
import { idToken } from './id_token';

let metadata;
idToken.subscribe(value => {
    metadata = {};
    if (value == null) return;
    metadata['authorization'] = `Bearer ${value.token}`;
});

const client = new ImageUploadServiceClient(`${SERVER_IP}`, null, {});

/**
 * @type {import('svelte/store').Writable<string>}
 */
export const uploadedImageUrl = writable('');

/**
 * Uploads an image and updates the store with the URL of the uploaded image.
 * @param {File} imageFile - The image file to upload.
 * @returns {Promise<void>}
 */
export async function uploadImage(imageFile) {
    const reader = new FileReader();
    console.log('Uploading image file of type:', imageFile.type);

    return new Promise((resolve, reject) => {
        reader.readAsArrayBuffer(imageFile);

        reader.onload = async () => {
            const buffer = reader.result;
            if (buffer === null) {
                reject(new Error('FileReader did not load the file correctly.'));
                return;
            }
            const request = new ImageUploadRequest();
            request.setImage(new Uint8Array(buffer));

            try {
                const response = await new Promise((innerResolve, innerReject) => {
                    client.uploadImage(request, metadata, (err, response) => {
                        if (err) {
                            innerReject(new Error('Failed to upload image: ' + err.message));
                        } else {
                            innerResolve(response);
                        }
                    });
                });
                uploadedImageUrl.set(response.getUrl());
                console.log('Image uploaded:', response.getUrl());
                resolve(response);
            } catch (error) {
                reject(error);
            }
        };

        reader.onerror = () => {
            reject(new Error('Error reading file: ' + reader.error.message));
        };
    });
}
